import { Transport } from './Transport.mjs';
import { ConsoleTransport } from './ConsoleTransport.mjs';
import { SentryTransport } from './SentryTransport.mjs';

const transports = {
  console: ConsoleTransport.initialize,
  sentry: SentryTransport.initialize
};

export {
  transports as default,
  ConsoleTransport,
  SentryTransport,
  Transport
};
